import serviceCommon from './common';
import cdnService from './cdn';
import commonUtil from '@/util/common';

const { env, isServerEnv } = window.globalData;

const pmsHosts = {
    ontest: 'https://api-pms-ontest.lixiang.com',
    preprod: 'https://api-pms-preprod.lixiang.com',
    prod: 'https://api-pms.lixiang.com'
};

const previewToken = commonUtil.getQueryStringByName('previewToken');

const getPageDetailUrl = () => {
    const useApiPms = !previewToken && isServerEnv;
    return `${
        useApiPms && pmsHosts[env] ? pmsHosts[env] : ''
    }/mall-pms-api/v1-0/page/cdn`;
}; // 获取变形金刚后台数据

export default {
    // 获取变形金刚后台数据
    async getPageDetail(code, option) {
        const res = await serviceCommon.serviceAjax(
            getPageDetailUrl(),
            'get',
            { ...option, code },
            {},
            {
                throwError: false,
                showErrorMessage: false,
                callback: null
            }
        );
        if (res && res.data && typeof res.data === 'string') {
            const cdn = await cdnService.getConfig(res.data);
            if (Object.prototype.toString.call(cdn) === '[object Object]') {
                return cdn;
            }
            return false;
        }
        return false;
    }
};
